import styled from 'styled-components';

export const Title = styled.h1`
  text-align: center;
  margin: 5rem 5rem;
`;

export default Title;
